(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-columns"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-columns-carousel')) {
  customElements.define('image-columns-carousel', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.image-columns__viewport');
      this.track = this.querySelector('.image-columns__grid');
      this.slides = [...this.track.children];
      this.mobile = window.matchMedia('(max-width: 768.98px)');
      this.update = () => {
        this.cancelLoad?.();
        if (!this.mobile.matches) {
          this.destroy();
          return;
        }
        this.cancelLoad = theme.prepareSwiper(this, () => {
          if (!this.isConnected || !this.mobile.matches || this.swiper) return;
          this.viewport.classList.add('swiper');
          this.track.classList.add('swiper-wrapper');
          this.slides.forEach((slide) => slide.classList.add('swiper-slide'));
          this.swiper = new window.Swiper(this.viewport, {
            slidesPerView: Number(this.dataset.slidesPerView) || 1.2,
            spaceBetween: Number(this.dataset.gap) || 0,
            watchOverflow: true,
            keyboard: { enabled: true },
            speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300
          });
        });
      };
      this.selectBlock = (event) => {
        const index = this.slides.indexOf(event.target.closest('.image-columns__item'));
        if (index >= 0) this.swiper?.slideTo(index);
      };
      this.mobile.addEventListener('change', this.update);
      this.addEventListener('shopify:block:select', this.selectBlock);
      this.update();
    }

    destroy() {
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.viewport.classList.remove('swiper');
      this.track.classList.remove('swiper-wrapper');
      this.slides.forEach((slide) => slide.classList.remove('swiper-slide'));
    }

    disconnectedCallback() {
      this.cancelLoad?.();
      this.mobile.removeEventListener('change', this.update);
      this.removeEventListener('shopify:block:select', this.selectBlock);
      this.destroy();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
